import { SERVER_ROUTES } from "../../enums/Enums";
import * as axiosActions from "../../managers/Axios/AxiosActions";
import { trackException } from "../Azure/ApplicationInsightsActions";


export const updateUserSiteActivation = (userSiteActivationEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = userSiteActivationEntity;

    axiosActions
      .PATCH(SERVER_ROUTES.UPDATE_USER_ACTIVATION, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - updateUserSiteActivation()",
          error
        );
        reject(error);
      });
  });
};

export const updateUserSitesActivation = (userSiteActivationEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = userSiteActivationEntity;

    axiosActions
      .PATCH(SERVER_ROUTES.UPDATE_USER_SITES_ACTIVATION, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - updateUserSitesActivation()",
          error
        );
        reject(error);
      });
  });
};

export const assignUserToSite = (siteOperationsEntity) => {
  return new Promise((resolve, reject) => {
    var requestBody = siteOperationsEntity;

    axiosActions
      .POST(SERVER_ROUTES.ADD_USER_SITE, requestBody)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - assignUserToSite()",
          error
        );
        reject(error);
      });
  });
};

export const updateUserToSite = (siteOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
  return new Promise((resolve, reject) => {
    var requestBody = siteOperationsEntity;

    axiosActions
      .PUT(SERVER_ROUTES.ADD_USER_SITE, requestBody, isShowSpinner, closeSpinner)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        trackException(
          "ActionsService.js - assignUserToSite()",
          error
        );
        reject(error);
      });
  });
};

export const unassignUserToSite = (siteOperationsEntity, isShowSpinner = true, closeSpinner = true) => {
    return new Promise((resolve, reject) => {
      var requestBody = siteOperationsEntity;
  
      axiosActions
        .DELETE(SERVER_ROUTES.UNASSIGN_USER_SITE, requestBody, isShowSpinner, closeSpinner)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          trackException(
            "ActionsService.js - assignUserToSite()",
            error
          );
          reject(error);
        });
    });
  };
